<ng-container *ngIf="maintenancePageActive === false; else maintenancePage">
  <ng-container *ngIf="(showPrimeModal$ | async) === false; else modalPrime">
    <app-header></app-header>
    <div [@transition]="routeAnimation" [ngClass]="notBodyScroll$(outlet) | async">
      <app-router-outlet #outlet="outlet"></app-router-outlet>
    </div>
    <app-footer *ngIf="(isMobile$ | async) === false"></app-footer>
  </ng-container>
</ng-container>

<ng-template #maintenancePage>
  <app-maintenance-page></app-maintenance-page>
</ng-template>

<ng-template #modalPrime>
  <app-modal-prime 
    [isMobile]="isMobile$ | async"
    [userInfo]="userInfo$ | async">
  </app-modal-prime>
</ng-template>